import React from 'react';

import { NavItem } from 'src/models/supernovaNaviMenu';

const AccountActions: React.FC<NavItem & React.PropsWithChildren> = ({ children }) => {
    return <div className="supernova-account-actions">{children}</div>;
};

export default AccountActions;
